import React from 'react'
import '../styles/resume.scss';

function Tab (props){
  return <div className="tabContent">{props.children}</div>
}

export default Tab;